module.exports = __webpack_public_path__ + "img/firstoff.e3e79d02.png";